export const networkCheckUrl = "https://google.com/"
export const version = 1.1
export const senderId = "dish_chat_client"
export const sentryDSN = ""
export const role = "user"

export const ga4MeasurementId = "ENTER_GA4_MEASUREMENT_ID"
export const amplitudeTrackingId = "ENTER_AMPLITUDE_KEY"
export const publicIpAddress = "https://api64.ipify.org?format=json"

export const socketUrl = `${process.env.REACT_APP_BASE_SOCKET_URL}/liveConversations`
export const brandName = process.env.REACT_APP_BRAND_NAME
export const botName = process.env.REACT_APP_BOT_NAME

export const botTriggeredTrackingUrl = `${process.env.REACT_APP_BASE_SOCKET_URL}/botTriggerLogging`
export const downloadChatlogUrl = `${process.env.REACT_APP_BASE_SOCKET_URL}/downloadChatHistory`
export const maintainanceUrl = `${process.env.REACT_APP_BASE_SOCKET_URL}/scheduleMaintainance`
export const googleAnalyticsLogging = `${process.env.REACT_APP_BASE_SOCKET_URL}/brand/${process.env.REACT_APP_BRAND_NAME}/googleAnalyticsLogging`
export const getOtpFormUrl = `${process.env.REACT_APP_BASE_SOCKET_URL}/brand/${process.env.REACT_APP_BRAND_NAME}/getOtpForm`
export const otpValidateUrl = `${process.env.REACT_APP_BASE_SOCKET_URL}/brand/${process.env.REACT_APP_BRAND_NAME}/userVerification`
